import React, { useEffect, useState } from "react";
import { Table, Input } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import AddEmployeeBankDetails from "./AddEmployeeBankDetails";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import { deleteEmployeeBankDetails, fetchEmployeeBankDetails } from "./store/employeeBankDetailsSlice";
import AddEditEmployeeBankDetail from "./AddEditEmployeeBankDetail";
const EmployeeBankDetailsDataTable = ({ data, loading }) => {
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { successMessage, error } = useSelector((state) => state.employeeBankDetailData);


  const handleDelete = (employeeId) => {
    dispatch(deleteEmployeeBankDetails(employeeId));
    setDeleteModalOpen(false);
  };

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
    }
    if (error) {
      toast.error(error);
    }
  }, [successMessage, error]);



  const columns = [
    {
        title: "Employee Code",
        dataIndex: "employee_code",
    },
    {
        title: "Bank Name",
        dataIndex: "bank_name",
    },
    {
        title: "Branch",
        dataIndex: "branch",
    },
    {
        title: "Account Number",
        dataIndex: "account_number",
    },
    {
        title: "IFSC Code",
        dataIndex: "ifsc_code",
    },
    {
        title: "Account Holder Name",
        dataIndex: "bank_account_holder_name",
    },
    {
        title: "Swift Code",
        dataIndex: "swift_code",
    },
    
    {
      title: "Action",
      render: (text, record) => (
        <div className="d-flex align-items-center">
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={`tooltip-delete-${record.id}`}>Delete</Tooltip>
            }
          >
            <Link
              className="btn btn-icon btn-danger btn-sm me-2" // Added "me-2" to add space between buttons
              to="#"
              onClick={() => {
                setSelectedEmployeeId(record.id);
                setDeleteModalOpen(true);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                backgroundColor: "#e74c3c",
                color: "#fff",
                fontSize: "18px",
                border: "none",
              }}
            >
              <i className="fa fa-trash" />
            </Link>
          </OverlayTrigger>

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-edit-${record.id}`}>Edit</Tooltip>}
          >
            <Link
              to="#"
              className="btn btn-icon btn-primary btn-sm me-2"
              onClick={() => {                
                setSelectedEmployeeId(record.id);
                setEditModalOpen(true);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                backgroundColor: "#3498db",
                color: "#fff",
                fontSize: "18px",
                border: "none",
              }}
            >
              <i className="fa fa-pencil" />
            </Link>
          </OverlayTrigger>

          
        </div>
      ),
    },
  ];

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="d-flex justify-content-end mb-4">
          <Input
            placeholder="Search Employee Name, Employee Code, Bank Account Number"
            style={{ width: 200 }}
            onKeyUp={(e) => {
              dispatch(fetchEmployeeBankDetails(e.target.value));
            }} 
          />
        </div>
        <div className="table-responsive">
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            rowKey="id"
            pagination={{
              pageSize: 10, // Keep a fixed number of items per page
              showSizeChanger: false, // Hide the "per page" dropdown
            }}
          />
          {isModalOpen && (
            <AddEmployeeBankDetails
              show={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              userId={selectedEmployeeId}
            />
          )}

          {isEditModalOpen && (
            <AddEditEmployeeBankDetail
              show={isEditModalOpen}
              onClose={() => setEditModalOpen(false)}
              employeeIds={selectedEmployeeId}
            />
          )}

          {deleteModalOpen && (
            <DeleteModal
              onConfirm={() => handleDelete(selectedEmployeeId)}
              onCancel={() => setDeleteModalOpen(false)}
              Name="Employee Bank Details"
            />
          )}
        </div>
      </div>
    </div>
  );
};


export default EmployeeBankDetailsDataTable
